import { defineFcm } from '../shared/factory';

export const FCM_AI_HERO_IMAGE_WATERMARK = defineFcm('ai_hero_image_watermark')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-starfish',
		scope: 'corgi-front-end',
		context: 'Petition details page hero image',
		description:
			'Gates the ai_hero_image_watermark_experiment, which bakes an AI-disclosure watermark into AI-generated petition hero images (CHANGE-98220).',
		import: false,
	});
